import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import React from "react";
import { useCitadel } from "@/hooks/use-citadel";
import { AddCostCenterModal } from "@/modals/cost-centers/add-cost-center-modal";

export function CostCentersMenu() {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const { citadel } = useCitadel();
	const addModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<Button
				icon={<Icon name="Plus" />}
				variant="primary"
				onClick={addModal.onOpen}
				isDisabled={!!citadel && citadel.cannot("create", "Organization")}
				data-cy="add-cost-center-button"
			>
				{t("cost_centers.add_cost_center")}
			</Button>
			<ModalWrapper>
				{addModal.isOpen && (
					<AddCostCenterModal
						isOpen={addModal.isOpen}
						onClose={addModal.onClose}
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
